var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.3,26.82c-.75,0-1.36.61-1.36,1.36h0v8.41c0,1.59-1.29,2.87-2.88,2.88H7.03c-1.59,0-2.87-1.29-2.88-2.88V7.75c0-1.59,1.29-2.88,2.88-2.88h9.59c.75,0,1.36-.61,1.36-1.36,0-.75-.61-1.36-1.36-1.36H7.03c-3.09,0-5.6,2.51-5.6,5.6v28.85c0,3.09,2.51,5.6,5.6,5.6h30.03c3.09,0,5.6-2.51,5.61-5.6v-8.41c0-.75-.61-1.36-1.36-1.36h0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.28,15.98c-.9,2.61.49,5.46,3.1,6.36,2.13.73,4.48-.05,5.75-1.91l2.28.87c-.02,1.27.55,2.47,1.56,3.24l-1.89,3.85c-2.12-.64-4.35.56-4.98,2.68s.56,4.35,2.68,4.98,4.35-.56,4.98-2.68c.42-1.39.05-2.9-.96-3.94l2.04-4.09c1.36.19,2.72-.32,3.6-1.36l2.13.8c.07,1.54,1.39,2.74,2.93,2.66,1.54-.07,2.74-1.39,2.66-2.93-.06-1.18-.85-2.2-1.98-2.54-1.05-.35-2.21-.05-2.96.77l-1.96-.75c.2-1.28-.24-2.57-1.17-3.46l.85-1.72c2.36.67,4.81-.7,5.48-3.05.67-2.36-.7-4.81-3.05-5.48-2.36-.67-4.81.7-5.48,3.05-.46,1.63.04,3.38,1.3,4.51l-.84,1.71c-1.66-.44-3.42.24-4.35,1.68l-2.1-.8c.38-2.74-1.52-5.26-4.26-5.65-2.32-.32-4.55,1-5.37,3.19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design-icon.ad20666bc543ab9aa2ca27be39ba4951.svg";
export { ForwardRef as ReactComponent };